<!-- 12小时面降雨量 -->
<template>
  <div class="ylbody">
    <div class="leftpic"></div>
    <div class="ylcontent">
        <div class="contentline"></div>
        <div class="ylcontitle">
            <span>12小时/全区面雨量</span>
        </div>
        <div class="ylcontnum">
            <span class="ylnum">150.0</span>
            <span class="scale">mm</span>
        </div>
    </div>
    <div class="ylcontent">
        <div class="contentline"></div>
        <div class="ylcontitle">
            <span>面雨量最大</span>
        </div>
        <div class="ylcontnum">
            <span class="ylnum2">漓渚镇</span>
            <span class="ylnum2">75.0</span>
            <span class="scale">mm</span>
        </div>
    </div>
    <div class="ylcontent">
        <div class="contentline"></div>
        <div class="ylcontitle">
            <span>单站最大</span>
        </div>
        <div class="ylcontnum">
            <span class="ylnum2">妙诸水库</span>
            <span class="ylnum2">55.0</span>
            <span class="scale">mm</span>
        </div>
      </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
  // 这里存放数据
    return {
      selectedToday: true,
      selected12Hours: false,
      selected24Hours: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 选择面降雨量时间
    selectedRainfallTime (index) {
      if (index === 'today') {
        this.selectedToday = true
        this.selected12Hours = false
        this.selected24Hours = false
      } else if (index === '12hours') {
        this.selected12Hours = true
        this.selectedToday = false
        this.selected24Hours = false
      } else if (index === '24hours') {
        this.selected24Hours = true
        this.selectedToday = false
        this.selected12Hours = false
      } else {}
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
  .leftpic{
      width: 260px;
      height: 280px;
      background-image: url(../../../assets/homepage_img/leftpic.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      float: left;
  }
  .ylcontent{
        width: 210px;
        height: 80px;
        background-color: #f0f2f6;
        float: right;
        margin-right: 15px;
        margin-top: 10px;
    }
    .ylcontent{
        width: 210px;
        height: 80px;
        background-color: #f0f2f6;
        float: right;
        margin-right: 15px;
        margin-top: 10px;
    }
    .contentline{
        height: 100%;
        float: left;
        border-left: 3px solid #3e7ffc;
    }
    .ylcontitle{
        font-family:Microsoft YaHei UI;
        font-size: 15px;
        color: #444444;
        text-align: left;
        width: 180px;
        float: left;
        margin-top: 10px;
        margin-left: 25px;
    }
    .ylcontnum{
        width: 180px;
        float: left;
        margin-top: 10px;
        margin-left: 25px;
        text-align: left;
    }
    .ylnum{
        font-family: Arial;
        font-size: 24px;
        color: #444444;
        font-style:italic;
        font-weight: 600;
    }
    .ylnum2{
        font-family: Microsoft YaHei UI;
        font-size: 16px;
        color: #444444;
        font-weight: 600;
    }
    .scale{
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #444444;
    }
</style>
